module.exports = __webpack_public_path__ + "img/About_item_5.83ec8b4b.jpg";